<section>
    @for (spirit of spirits; track spirit.uuid) {
        <app-grid-item [spirit]="spirit" [menu]="menu" [lockerUser]="lockerUser" (goToDetail)="navigate($event)"></app-grid-item>
    }
</section>